module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ListSensorWarnings":"List Sensor Warnings"},"vi":{"ListSensorWarnings":"Danh sách cảnh báo"}}')
  delete Component.options._Ctor
}
